module.exports = __webpack_public_path__ + "static/img/indexbg.cf8cf5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/indexbg.jpg
// module id = 8DoR
// module chunks = 1